function periodIsValid(plan: Plan, period: string | number | undefined): boolean {
  return !period ? false : Boolean(plan.durations && plan.durations[period.toString()])
}

export default periodIsValid
